<template>
  <!-- errorReport Modal -->
  <div
    class="modal fade"
    id="errorReportModal"
    tabindex="-1"
    aria-labelledby="errorReportModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="errorReportModalLabel">
            Download Error Report
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          There is no error report available for download.
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 100%"
            data-bs-dismiss="modal"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- reportDetails Modal -->
  <div
    class="modal fade"
    id="reportDetailsModal"
    tabindex="-1"
    aria-labelledby="reportDetailsModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="reportDetailsModalLabel">
            Download Report Details
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          There is no report details available for download.
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 100%"
            data-bs-dismiss="modal"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- test Modal -->
  <div
    class="modal fade"
    id="testModal"
    tabindex="-1"
    aria-labelledby="testModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="testModalLabel">TEST</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">Testing</div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 100%"
            data-bs-dismiss="modal"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
